import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "v-collapse-content" }

import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VCollapseContent',
  props: {
    height: null
  },
  setup(__props: any, { expose }) {

const props = __props as { height?: number }


const opened = ref(false)

const fullHeight = ref(props.height || 84)
const overflow = computed(() => fullHeight.value - 2 > (props.height || 84))
const itemsHidden = ref(0)

const style = computed(() => ({
  maxHeight: ((opened.value || !overflow.value)? fullHeight.value: (props.height || 84)) + 'px'
}))

const calc = () => {
  if (!parentRef.value) return
  if (parentRef.value.children.length === 0) {
    fullHeight.value = 0
    return
  }
  const lastChild = parentRef.value.children[parentRef.value.children.length-1] as HTMLElement
  const parentRect = parentRef.value.getBoundingClientRect()
  const height = lastChild.getBoundingClientRect().bottom - parentRect.top
  fullHeight.value = height

  if (!overflow.value) return
  for (let i = 0; i < parentRef.value.children.length; i++) {
    const child = parentRef.value.children[i]
    if (child.getBoundingClientRect().top > parentRect.top + (props.height || 84) - 2) {
      itemsHidden.value = parentRef.value.children.length - i
      break
    }
  }
}

const parentRef = ref<HTMLDivElement>()
onMounted(() => calc())

expose({
  update: calc
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "parentRef",
      ref: parentRef,
      class: "v-collapse-content__inner",
      style: _normalizeStyle(_unref(style))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 4),
    (_unref(overflow))
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "v-collapse-content__more-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (opened.value = !opened.value))
        }, [
          (!opened.value)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(itemsHidden.value? ("+"+itemsHidden.value): "More"), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createTextVNode("Hide")
              ], 64))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})